var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnoop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    fill: "white",
    stroke: "#727272"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2614 20H9.39773L13.5852 8.36364H15.6136L19.8011 20H17.9375L14.6477 10.4773H14.5568L11.2614 20ZM11.5739 15.4432H17.6193V16.9205H11.5739V15.4432Z",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnoop);
export default __webpack_public_path__ + "static/media/Anoop.7a7f25bac7d4267e6fd7e4cd52078077.svg";
export { ForwardRef as ReactComponent };